import { useTranslation } from "react-i18next";
import Table from "../../../components/table/table";
import BoxIcon from "../../../icons/boxIcon";
import CalculatorIcon from "../../../icons/calculatorIcon";
import CubicMeterCalculator from "./cubicMeterCalculator";
import CylindricalParcelCalculator from "./cylindricalParcelCalculator";
import VolumetricWeightCalculator from "./volumetricWeightCalculator";

const ShippingCalculator = () => {
  const { t } = useTranslation();
  const tableHead = [
    {
      header: t("volumeCBM"),
      accessorKey: "volume",
    },
    {
      header: t("containerSizeFeet"),
      accessorKey: "size",
    },
  ];
  const tableData = [
    {
      volume: "33 CBM",
      size: "20 ft",
    },
    {
      volume: "67.3 CBM",
      size: "40 ft",
    },
    {
      volume: "76 CBM",
      size: "40 ft High Cube",
    },
    {
      volume: "85.7 CBM",
      size: "45 ft High Cube",
    },
  ];
  return (
    <main>
      <article className="py-20">
        <div className="w-11/12 mx-auto ">
          <span className="block mx-auto w-fit">
            <CalculatorIcon fill="#0051FF" className={"size-[60px]"} />
          </span>
          <h1 className="text-[24px] my-5 md:text-[32px] font-bold text-mainBlue text-center">
            {t("shippingCalculators")}
          </h1>
          <p className="my-5 text-center text-mainGray">{t("onlineTool")}</p>
          <div className="space-y-10">
            <Table
              TableData={tableData}
              TableHead={tableHead}
              header={t("containerSizes")}
              icon={<BoxIcon className="size-6" />}
            />
            <VolumetricWeightCalculator />
            <CubicMeterCalculator />
            <CylindricalParcelCalculator />
          </div>
        </div>
      </article>
    </main>
  );
};

export default ShippingCalculator;
